import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, shareReplay, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../common/global';
import { ApiOrderResponse, Order } from '../common/event.model';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private readonly orderSubject = new BehaviorSubject<Order | null>(null);
  order$ = this.orderSubject.asObservable();
  private readonly orderRequests = new Map<number, Observable<Order>>();

  constructor(
    private readonly http: HttpClient,
  ) {}

  getOrder(orderId: number, refresh: boolean = false): Observable<Order> {    
    if (refresh) {
      this.orderRequests.delete(orderId);
      this.orderSubject.next(null);
    }

    if (!this.orderRequests.has(orderId)) {
      const headers = new HttpHeaders(GlobalConstants.headersCentral.headers);
      const request$ = this.http
        .get<ApiOrderResponse>(
          `${environment.apiUrl}/conn/${environment.connId}/v1/orders/${orderId}`,
          { headers }
        )
        .pipe(
          map(response => {
            if (!response.success) {
              throw new Error();
            }

            return response.data;
          }),
          tap(order => this.orderSubject.next(order)),
          shareReplay({ bufferSize: 1, refCount: true })
        );

      this.orderRequests.set(orderId, request$);
    }

    return this.orderRequests.get(orderId)!;
  }
}
